import { defineStore } from 'pinia';
import axios from 'axios';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,          // { id, nume, tip_cont, ... }
    firmaCurenta: null,  // { id }  (server return is just the id)
    loaded: false,
  }),

  getters: {
    isLogged: (s) => !!s.user?.id,
    isAdmin:  (s) => String(s.user?.tip_cont ?? '').toLowerCase() === 'admin' || s.user?.tip_cont === 1,
    firmaId:  (s) => (typeof s.firmaCurenta === 'number' ? s.firmaCurenta : s.firmaCurenta?.id ?? null),
  },

  actions: {
    async fetchMe(opts = {}) {
      const { redirectOn401 = false, silent401 = true } = opts;
      try {
        // Evită apelul pe pagina de login
        if (typeof window !== 'undefined') {
          const p = window.location?.pathname || '';
          if (p === '/login' || p.startsWith('/login/')) {
            this.user = null;
            this.firmaCurenta = null;
            return;
          }
        }

        const { data } = await axios.get('/api/cont', {
          // withCredentials: true, // deblochează dacă API-ul cere cookie (Sanctum)
          validateStatus: (s) => (s >= 200 && s < 300) || s === 401 || s === 419,
        });

        if (!data || data.message === 'Unauthenticated.') {
          // Echivalent 401 din API
          this.user = null;
          this.firmaCurenta = null;
          if (redirectOn401) {
            if (typeof window !== 'undefined') window.location = '/login';
          }
          return;
        }

        this.user = {
          ...data.user,
          firma_curenta: data.firma_curenta
        };

        const fcRaw = data.firma_curenta ?? null;
        this.firmaCurenta = (fcRaw && typeof fcRaw === 'object')
          ? {
              id: fcRaw.id,
              denumire: fcRaw.denumire ?? '',
              stare_firma: fcRaw.stare_firma ?? null
            }
          : (typeof fcRaw === 'number' || typeof fcRaw === 'string')
            ? { id: Number(fcRaw), stare_firma: null }
            : null;
      } catch (e) {
        const status = e?.response?.status;
        if ((status === 401 || status === 419) && silent401) {
          // starea neautentificat: păstrăm tăcere, doar resetăm store-ul
          this.user = null;
          this.firmaCurenta = null;
        } else {
          console.warn('fetchMe error:', e);
          this.user = null;
          this.firmaCurenta = null;
        }
      } finally {
        this.loaded = true;
      }
    },

    // setează explicit (de ex. după schimbarea firmei)
    setUser(user) {
      this.user = user || null;
    },
    setFirmaCurenta(firma) {
      this.firmaCurenta = (firma && typeof firma === 'object')
        ? firma
        : (typeof firma === 'number' || typeof firma === 'string')
          ? { id: Number(firma) }
          : null;
    },

    // logout / reset store rapid
    clear() {
      this.user = null;
      this.firmaCurenta = null;
      this.loaded = false;
    },

    // fallback temporar dacă încă folosești meta tags
    hydrateFromMeta() {
      try {
        if (typeof document === 'undefined') {
          this.loaded = true;
          return;
        }
        const get = (n) => document.querySelector(`meta[name="${n}"]`)?.content;
        const id  = get('user_id');
        const tip = get('tip_cont');
        const fid = get('firma_curenta');

        if (id)  this.user = { ...(this.user || {}), id: Number(id), tip_cont: tip };
        if (fid) this.firmaCurenta = { ...(this.firmaCurenta || {}), id: Number(fid) };
      } catch (e) {
        console.warn('hydrateFromMeta warn:', e);
      } finally {
        this.loaded = true;
      }
    },
  },

  // Dacă vrei persistență automată în localStorage:
  // persist: true,
});